"use client";
import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { BiSolidChevronUpCircle } from "react-icons/bi";
import HtmlParser from "./HtmlParser";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderTop: `1px solid ${theme.palette.divider}`,
  marginBottom: "10px",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <BiSolidChevronUpCircle
        style={{ fontSize: "1.5rem", color: "#fe5200" }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "#fff",
  color: "#0e2b3d",
  padding: "5px",
  borderRadius: "4px",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    marginTop: "0px",
    marginBottom: "0px",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: "8px",
}));

const CommonAccordion: React.FC<any> = ({
  data,
  type = "closed",
}) => {
  const [expanded, setExpanded] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (type === "closed") {
      setExpanded(data.length ? [data[0]?.Title] : []);
    } else if (type === "open") {
      setExpanded(data.map((d:any) => d.Title));
    }
  }, [data, type]);

  const handleChange =
    (panel: string) => (_: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded((prevExpanded) =>
        newExpanded
          ? [...prevExpanded, panel] 
          : prevExpanded.filter((item) => item !== panel) 
      );
    };

  if (!data.length) return null;

  return (
    <>
      {data.map((a:any, i:any) => (
        <Accordion
          key={a.Title || `panel-${i}`}
          expanded={expanded.includes(a?.Title)}
          onChange={handleChange(a.Title)}
        >
          <AccordionSummary
            aria-controls={`panel${i}-content`}
            id={`panel${i}-header`}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              paddingTop: "15px",
            }}
          >
            {a.Count ? (
              <p className="w-[30px] h-[30px] rounded-full bg-secondary-light/50 flex items-center justify-center mb-0">
                {a.Count}
              </p>
            ) : null}
            <h6 className="lg:text-lg flex flex-1 text-sm font-bold ml-5">
              {a.Title}
            </h6>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "10px",
            }}
          >
            {a?.Component ? (
              a.Component
            ) : (
              <div className="prod-desc text-sm text-[#4e4e4e] leading-6 text-justify w-[92%] mx-auto">
                <HtmlParser html={a?.Description} />
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default CommonAccordion;
